import { ModelExampleVO } from '@wizeoo/akm-common-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'ag-freedata-example-action-renderer',
  templateUrl: './ag-freedata-example-action.renderer.html',
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Renderer des actions sur un modèle de codification dans le grid
 */
export class AgFreedataExampleActionRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  modelExample: ModelExampleVO;

  refresh(params: ICellRendererParams): boolean {
    this.modelExample = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.modelExample = params.data;
    this.cdref.markForCheck();
  }
}
